import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAward,
  faCogs,
  faShieldAlt,
  faHandshake,
  faLeaf,
  faUsers,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";

const values = [
  {
    icon: faAward,
    title: "Unmatched Expertise",
    description:
      "Over 25 years of experience with a team of skilled professionals ensuring flawless results.",
  },
  {
    icon: faCogs,
    title: "Cutting-edge Technology",
    description:
      "Latest electroplating equipment enabling a wide range of finishes for demanding requirements.",
  },
  {
    icon: faShieldAlt,
    title: "Quality Assurance",
    description:
      "Stringent quality control measures guaranteeing the highest industry standards.",
  },
  {
    icon: faHandshake,
    title: "Custom Solutions",
    description:
      "Tailor-made solutions developed closely with clients to match specific needs and vision.",
  },
  {
    icon: faLeaf,
    title: "Eco-Friendly",
    description:
      "Environmentally responsible practices with compliance to all relevant regulations.",
  },
  {
    icon: faUsers,
    title: "Customer Focus",
    description:
      "Dedicated support team committed to exceeding expectations on every project.",
  },
];

const timeline = [
  { year: "1998", event: "Founded in Zouk, Lebanon" },
  { year: "2005", event: "Expanded to serve automotive industry" },
  { year: "2010", event: "Introduced advanced anodizing services" },
  { year: "2015", event: "Achieved ISO quality certification" },
  { year: "2020", event: "Modernized facility with latest technology" },
  { year: "Today", event: "Serving 500+ clients across 6 industries" },
];

const AboutContent = () => {
  return (
    <>
      {/* Story Section */}
      <section className="about-story-section">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="about-story-content">
              <span className="section-label">Our Story</span>
              <h2 className="about-story-title">A Legacy of Excellence</h2>
              <p className="about-story-text">
                Founded in April 1998, ElectroplatingLB has grown from a small workshop
                to become Lebanon's premier electroplating and metal finishing company.
                With over two decades of experience, we've established ourselves as a
                reliable and innovative partner for businesses across multiple industries.
              </p>
              <p className="about-story-text">
                Our journey has been defined by continuous improvement, investment in
                cutting-edge technology, and an unwavering commitment to quality. Today,
                we serve over 500 clients, transforming ordinary metals into extraordinary
                finishes that enhance both performance and aesthetics.
              </p>
              <div className="about-stats-inline">
                <div className="about-stat-item">
                  <span className="about-stat-number">25+</span>
                  <span className="about-stat-label">Years</span>
                </div>
                <div className="about-stat-item">
                  <span className="about-stat-number">500+</span>
                  <span className="about-stat-label">Clients</span>
                </div>
                <div className="about-stat-item">
                  <span className="about-stat-number">6</span>
                  <span className="about-stat-label">Industries</span>
                </div>
              </div>
            </Col>
            <Col lg={6} className="about-story-image-col">
              <div className="about-image-grid">
                <Image
                  src="./assets/car.jpeg"
                  alt="Electroplating work"
                  className="about-image-main"
                />
                <div className="about-image-badge">
                  <span className="badge-year">Since</span>
                  <span className="badge-number">1998</span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Mission Section */}
      <section className="about-mission-section">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="order-lg-2">
              <span className="section-label">Our Mission</span>
              <h2 className="about-mission-title">Committed to Excellence</h2>
              <p className="about-mission-text">
                At ElectroplatingLB, our mission is to deliver exceptional electroplating
                and metal finishing services that enhance the performance, durability,
                and aesthetics of our customers' products.
              </p>
              <ul className="about-mission-list">
                <li>
                  <FontAwesomeIcon icon={faCheck} className="check-icon" />
                  Advanced technologies and eco-friendly processes
                </li>
                <li>
                  <FontAwesomeIcon icon={faCheck} className="check-icon" />
                  Skilled craftsmanship exceeding expectations
                </li>
                <li>
                  <FontAwesomeIcon icon={faCheck} className="check-icon" />
                  Contributing to a sustainable future
                </li>
                <li>
                  <FontAwesomeIcon icon={faCheck} className="check-icon" />
                  Continuous innovation and improvement
                </li>
              </ul>
            </Col>
            <Col lg={6} className="order-lg-1 about-mission-image-col">
              <Image
                src="./assets/lamp.jpeg"
                alt="Quality craftsmanship"
                className="about-mission-image"
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* Values Section */}
      <section className="about-values-section">
        <Container>
          <div className="section-header">
            <span className="section-label">Why Choose Us</span>
            <h2 className="section-title">Our Core Values</h2>
            <p className="section-subtitle">
              What sets us apart and drives our commitment to excellence
            </p>
          </div>
          <Row className="values-grid">
            {values.map((value, index) => (
              <Col md={6} lg={4} key={index}>
                <div className="value-card">
                  <div className="value-icon">
                    <FontAwesomeIcon icon={value.icon} />
                  </div>
                  <h3 className="value-title">{value.title}</h3>
                  <p className="value-description">{value.description}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Timeline Section */}
      <section className="about-timeline-section">
        <Container>
          <div className="section-header">
            <span className="section-label">Our Journey</span>
            <h2 className="section-title">Company Timeline</h2>
          </div>
          <div className="timeline">
            {timeline.map((item, index) => (
              <div className="timeline-item" key={index}>
                <div className="timeline-content">
                  <span className="timeline-year">{item.year}</span>
                  <p className="timeline-event">{item.event}</p>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>
    </>
  );
};

export default AboutContent;
